import { i as y, b as g, a as m, S as s } from "./isArray.CdbPONHA.js";
var l = "[object Symbol]";
function S(t) {
  return typeof t == "symbol" || y(t) && g(t) == l;
}
function a(t, n) {
  for (var r = -1, i = t == null ? 0 : t.length, o = Array(i); ++r < i; )
    o[r] = n(t[r], r, t);
  return o;
}
var e = s ? s.prototype : void 0, f = e ? e.toString : void 0;
function b(t) {
  if (typeof t == "string")
    return t;
  if (m(t))
    return a(t, b) + "";
  if (S(t))
    return f ? f.call(t) : "";
  var n = t + "";
  return n == "0" && 1 / t == -1 / 0 ? "-0" : n;
}
function p(t) {
  return t == null ? "" : b(t);
}
export {
  a,
  S as i,
  p as t
};
